import {
	agreementsColumnsPopOverState,
	agreementsIFilterPopOverState,
	casesIFilterPopOverState,
	documentsIFilterPopOverState,
	formsIFilterPopOverState,
	publicAgreementsIFilterPopOverState,
	recordsIFilterPopOverState,
	refundsIFilterPopOverState,
	modelsIFilterPopOverState,
} from "../../../store/lyfe-data-table";
import { TableTypes } from "../LyfeDataTable";

export default function getFilterByState(type: TableTypes) {
	switch (type) {
		case "forms":
			return formsIFilterPopOverState;
		case "records":
			return recordsIFilterPopOverState;
		case "cases":
			return casesIFilterPopOverState;
		case "agreements":
			return agreementsIFilterPopOverState;
		case "publicAgreements":
			return publicAgreementsIFilterPopOverState;
		case "models":
			return modelsIFilterPopOverState;
		case "documents":
			return documentsIFilterPopOverState;
		case "transactions":
			return refundsIFilterPopOverState;
		default:
			console.error(`no value for ${type} in getFilterByState`);
			return formsIFilterPopOverState;
	}
}

export function getColumnsByState() {
	return agreementsColumnsPopOverState;
}
